// extracted by mini-css-extract-plugin
export default {"galleryWrapper":"galleryCard_galleryWrapper__jmDLm"};